import { extend } from 'underscore';
import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

const {
  helpbuttonStyle,
} = ComponentSettings;

export const getStyles = (_, { palette = {} }) => ({
  '@global': extend(
    {},
    helpbuttonStyle({ palette })
  ),
  importCalloutCardPopup: {
    minWidth: 450,
    maxWidth: 450,

    '& .import-callout-card-content': {
      fontSize: 14,

      '& .import-callout-card-content-link': {
        paddingLeft: 3,
      },
    },

    '& .import-callout-card-coupon': {
      lineHeight: 2.5,
      paddingTop: 5,
      color: palette.green,
      fontWeight: 'bold',
    },

    '& .import-callout-card-buttons': {
      display: 'flex',
      paddingTop: 20,
      justifyContent: 'flex-end',
      '& button': {
        marginLeft: 10,
      },
    },
  },
});
